"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductCardNew = void 0;
var _react = _interopRequireDefault(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _shopeeCommon = require("@mkt-common/shopee-common");
var _Button = require("../Button");
var _defaultUserAvatar = _interopRequireDefault(require("../../assets/images/default-user-avatar.png"));
var ProductCardNew = function ProductCardNew(props) {
  var title = props.title,
    itemCount = props.itemCount,
    totalPrice = props.totalPrice,
    orderSn = props.orderSn,
    orderStatusText = props.orderStatusText,
    image = props.image,
    userImg = props.userImg,
    selectOrderText = props.selectOrderText,
    totalPaymentText = props.totalPaymentText,
    itemsText = props.itemsText,
    itemText = props.itemText,
    _props$isOrderSelect = props.isOrderSelect,
    isOrderSelect = _props$isOrderSelect === void 0 ? false : _props$isOrderSelect,
    _props$productID = props.productID,
    productID = _props$productID === void 0 ? '' : _props$productID,
    _props$stock = props.stock,
    stock = _props$stock === void 0 ? 0 : _props$stock,
    _props$stockText = props.stockText,
    stockText = _props$stockText === void 0 ? '' : _props$stockText,
    _props$productIDText = props.productIDText,
    productIDText = _props$productIDText === void 0 ? '' : _props$productIDText,
    _props$orderIDText = props.orderIDText,
    orderIDText = _props$orderIDText === void 0 ? '' : _props$orderIDText,
    _props$orderUserName = props.orderUserName,
    orderUserName = _props$orderUserName === void 0 ? '' : _props$orderUserName,
    _props$orderID = props.orderID,
    orderID = _props$orderID === void 0 ? '' : _props$orderID;
  var prefixCls = (0, _getPrefixCls.getPrefixCls)('product-new');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-container"),
    key: orderSn
  }, isOrderSelect && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-productHeadTitle")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-productHeadLeftTitle")
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "".concat(prefixCls, "-productHeadImg"),
    src: userImg ? (0, _shopeeCommon.cdnFile)(userImg) : _defaultUserAvatar.default,
    alt: "item"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-productHeadLeftText")
  }, orderUserName)), (orderIDText === null || orderIDText === void 0 ? void 0 : orderIDText.length) > 0 && /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-productHeadRightText")
  }, orderIDText, ': ', orderID)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-productItem")
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "".concat(prefixCls, "-productItemImg"),
    src: (0, _shopeeCommon.cdnFile)(image),
    alt: "item"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-productItemTitle")
  }, title), !isOrderSelect ? /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-productItemSpec")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-productID")
  }, (productIDText === null || productIDText === void 0 ? void 0 : productIDText.length) > 0 && /*#__PURE__*/_react.default.createElement("span", null, productIDText, ': ', productID)), (stockText === null || stockText === void 0 ? void 0 : stockText.length) > 0 && /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-productStock")
  }, stockText, ': ', stock)) : /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-productItemSpec")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-productID")
  }, itemCount, " ", itemCount || Number(itemCount) > 1 ? itemsText : itemText, ', '), /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-productID")
  }, totalPaymentText, ': ', /*#__PURE__*/_react.default.createElement("span", null, totalPrice))), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-selectFooter")
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-productStatus")
  }, orderStatusText)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-buttonsWarpper")
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    className: "".concat(prefixCls, "-productButton"),
    type: "primary",
    text: selectOrderText
  })))));
};
exports.ProductCardNew = ProductCardNew;